import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    //设置属性
    defaultSearchData: '',
    defaultRadio: '',
    loginTip: null
  },
  mutations: {
    //
    changeDefaultSearchData(state, str) {
      state.defaultSearchData = str.i;
      state.defaultRadio = str.o;
      console.log(str)
    },
    SET_LOGIN_TIP: (state, value) => {
      state.loginTip = value
    }
  },
  actions: {
    setLoginTip({ commit }, value) {
      commit('SET_LOGIN_TIP', value)
    },
  },
  modules: {}
});
